import { BetaBanner } from '@/components/BetaBanner';
import { Footer } from '@/components/Footer';
import { TrialBanner } from '@/components/TrialBanner';

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <BetaBanner />
      <TrialBanner />
      <div className="flex-1">{children}</div>
      <Footer />
    </div>
  );
}
